import React, { FC, ReactNode } from 'react';

type TPromptDetailsItemProps = {
  children: ReactNode;
};

const PromptDetailsItem: FC<TPromptDetailsItemProps> = ({ children }) => (
  <div className="flex items-center">{children}</div>
);

export default PromptDetailsItem;
